import {
  PORTAL_URL,
  subscribeToConfigChanges
} from '~/common/helpers/environment';

let currentPortalUrl = PORTAL_URL;

// Subscribe to config changes to get updated PORTAL_URL
subscribeToConfigChanges(config => {
  if (config.PORTAL_URL) {
    currentPortalUrl = config.PORTAL_URL;
  }
});

const getSubdomain = () => {
  if (!currentPortalUrl) return null;

  const { hostname } = window.location;
  const portalUrl = currentPortalUrl?.replace?.(/{([^}]*)}./, '');

  if (hostname?.split?.('.')?.length <= portalUrl?.split?.('.')?.length)
    return null;

  return hostname?.split?.('.')?.[0];
};

export default getSubdomain;
